import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageWithTitle } from 'src/shared/components/PageWithTitle';
import { WithForm } from 'src/shared/HOC/WithForm';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import { Tab1 } from './Tabs/Tab1';
import { Tab2 } from './Tabs/Tab2';

export enum FlexflowContractsTab {
  BEFORE_ACTIVATION = 'before_activation',
  AFTER_ACTIVATION = 'after_activation'
}

const Contracts = () => {
  const { t } = useTranslation(['nav', 'flexflow']);
  const pageTitle = t('items.manage employees');
  const [tab, setTab] = useState(FlexflowContractsTab.BEFORE_ACTIVATION);

  const handleTabChange = (event: React.SyntheticEvent, newValue: FlexflowContractsTab) => {
    setTab(newValue);
  };

  return (
    <WithForm initialValues={undefined}>
      <PageWithTitle title={pageTitle}>
        <TabContext value={tab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabChange} aria-label={pageTitle}>
              <Tab
                label={t('manage employees.tab1', { ns: 'flexflow' })}
                value={FlexflowContractsTab.BEFORE_ACTIVATION}
              />
              <Tab
                label={t('manage employees.tab2', { ns: 'flexflow' })}
                value={FlexflowContractsTab.AFTER_ACTIVATION}
              />
            </TabList>
          </Box>
          <TabPanel sx={{ padding: '32px 0' }} value={FlexflowContractsTab.BEFORE_ACTIVATION}>
            <Tab1 />
          </TabPanel>
          <TabPanel sx={{ padding: '32px 0' }} value={FlexflowContractsTab.AFTER_ACTIVATION}>
            <Tab2 />
          </TabPanel>
        </TabContext>
      </PageWithTitle>
    </WithForm>
  );
};

export default Contracts;
